import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";
import { DepositContext } from "@state/context/payment/DepositContext";
import { LimitSteps } from "@utils/limits/limitSteps";
import { observer } from "mobx-react";

export default observer(function DepositLimitPartialDeposit() {
	const depositStore = useContext(DepositContext);

	const rootStore = useRootAppStore();

	const { t } = useTranslation("my-limits");

	if (
		depositStore.depositLimitStore.activeStep !==
		LimitSteps.PARTIAL_DEPOSIT_AFTER_LIMIT_INCREASE
	) {
		return null;
	}

	return (
		<>
			<div className="popup__body">
				<div className="message message--base message--warning">
					<i className="message__icon u-icon u-icon--lrg u-icon--alert-circle u-color--sent--warning" />
					<div className="message__content">
						{t("DEPOSIT_LIMIT_REACHED_PARTIAL_ONLY", {
							0: depositStore.depositLimitStore.limitData
								?.availableBudget,
							1: rootStore.userAuthStore.currency,
						})}
					</div>
				</div>
			</div>
			<div className="popup__footer">
				<button
					type="button"
					className="at-accVerifBtnSecondary popup__btn btn btn--med btn--primary--inverted"
					onClick={() => {
						depositStore.depositLimitStore.deactivateDepositLimitPopup(
							true
						);
					}}
				>
					{t("PARTIAL_DEPOSIT")}
				</button>
			</div>
		</>
	);
});
